import { render } from "./ChartRadar.vue?vue&type=template&id=401c6f51"
import script from "./ChartRadar.vue?vue&type=script&lang=js"
export * from "./ChartRadar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/ChartRadar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "401c6f51"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('401c6f51', __exports__)) {
    api.reload('401c6f51', __exports__)
  }
  
  module.hot.accept("./ChartRadar.vue?vue&type=template&id=401c6f51", () => {
    api.rerender('401c6f51', render)
  })

}


export default __exports__